import { lazy, Suspense } from 'react'
import type { FC } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { routes } from '@/router/routes'
import {
  AuthPage,
  HomePage,
  RetailPage,
} from '@/pages'

const GasStationPage = lazy(() => import('@/pages/gas-station').then(m => ({ default: m.GasStationPage })))
const CabinetPage = lazy(() => import('@/pages/cabinet').then(m => ({ default: m.CabinetPage })))
const ProfilePage = lazy(() => import('@/pages/profile').then(m => ({ default: m.ProfilePage })))
// const StructurePage = lazy(() => import('@/pages/structure').then(m => ({ default: m.StructurePage })))
const FuelingPage = lazy(() => import('@/pages/gas-station/subpages/fueling').then(m => ({ default: m.FuelingPage })))
const FuelingCompletePage = lazy(() => import('@/pages/gas-station/subpages/fueling-complete').then(m => ({ default: m.FuelingCompletePage })))
const TravelPage = lazy(() => import('@/pages/travel').then(m => ({ default: m.TravelPage })))
const HelpPage = lazy(() => import('@/pages/help').then(m => ({ default: m.HelpPage })))
const HelpTicketCreatePage = lazy(() => import('@/pages/help/subpages/ticket-create').then(m => ({ default: m.HelpTicketCreatePage })))
const HelpTicketConversationPage = lazy(() => import('@/pages/help/subpages/ticket-conversation').then(m => ({ default: m.HelpTicketConversationPage })))


export const AppRouter: FC = () => {
  return (
    <Routes>
      <Route path={routes.auth} element={<AuthPage />} />

      <Route path={routes.home} element={<HomePage />} />
      <Route path={routes.topupReturnPlaceholder} element={<HomePage />} />

      <Route
        path={routes.cabinet}
        element={<Suspense fallback={null}><CabinetPage /></Suspense>}
      />

      <Route
        path={routes.profile}
        element={<Suspense fallback={null}><ProfilePage /></Suspense>}
      />

      {/* structure — временно отключено
      <Route
        path={routes.structure}
        element={<Suspense fallback={null}><StructurePage /></Suspense>}
      />
      */}

      <Route path={routes.retail} element={<RetailPage />} />

      <Route
        path={routes.gasStation}
        element={<Suspense fallback={null}><GasStationPage /></Suspense>}
      />
      <Route
        path={routes.gasStationFueling}
        element={<Suspense fallback={null}><FuelingPage /></Suspense>}
      />
      <Route
        path={routes.gasStationFuelingByIdPlaceholder}
        element={<Suspense fallback={null}><FuelingPage /></Suspense>}
      />
      <Route
        path={routes.gasStationFuelingWildcardPlaceholder}
        element={<Suspense fallback={null}><FuelingPage /></Suspense>}
      />
      <Route
        path={routes.gasStationFuelingComplete}
        element={<Suspense fallback={null}><FuelingCompletePage /></Suspense>}
      />

      <Route
        path={routes.travel}
        element={<Suspense fallback={null}><TravelPage /></Suspense>}
      />

      <Route
        path={routes.help}
        element={<Suspense fallback={null}><HelpPage /></Suspense>}
      />
      <Route
        path={routes.helpTicketCreate}
        element={<Suspense fallback={null}><HelpTicketCreatePage /></Suspense>}
      />
      <Route
        path={routes.helpTicketConversationPlaceholder}
        element={<Suspense fallback={null}><HelpTicketConversationPage /></Suspense>}
      />

      <Route path='*' element={<Navigate replace to={routes.home} />} />
    </Routes>
  )
}
